/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { Search, TOOLBAR_ITEM_TYPE, TOOLBAR_VIEW_TYPE } from '@veeam-vspc/components';

import type { PublicCloudVmRestoreType } from '@veeam-vspc/models/web-controllers';

import { useLang } from 'views/providers/LangProvider/hooks';
import { ToolbarWithExport } from 'views/components/ToolbarWithExport';
import { getSearchFieldPlaceholder } from '../../utils';

import type { ToolbarWithExportProps } from 'views/components/ToolbarWithExport';

export interface PublicCloudsDialogToolbarProps extends Omit<ToolbarWithExportProps, 'method' | 'items'> {
    backupType: PublicCloudVmRestoreType;
    method?: string;
}

export const PublicCloudsDialogToolbar: React.FC<PublicCloudsDialogToolbarProps> = (props) => {
    const { backupType, method = 'GetPublicCloudVmBackup', ...restProps } = props;
    const lang = useLang();

    return (
        <ToolbarWithExport
            {...restProps}
            method={method}
            view={TOOLBAR_VIEW_TYPE.spotted}
            items={[
                {
                    type: TOOLBAR_ITEM_TYPE.customControl,
                    render: () => (
                        <Search
                            name='jobName'
                            placeholder={getSearchFieldPlaceholder(backupType, lang)}
                            hasSearchButton={true}
                        />
                    ),
                },
            ]}
        />
    );
};
